import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import jabvoxAffiliatePortal from './jabvoxAffiliatePortal.json';
import jabvoxAffiliates from './jabvoxAffiliates.json';
import jabvoxAiChat from './jabvoxAiChat.json';
import jabvoxProvisioningChat from './jabvoxProvisioningChat.json';
import jabvoxAudioAnalysis from './jabvoxAudioAnalysis.json';
import jabvoxAnalytics from './jabvoxAnalytics.json';
import jabvoxCdr from './jabvoxCdr.json';
import jabvoxCalendar from './jabvoxCalendar.json';
import jabvoxDialer from './jabvoxDialer.json';
import jabvoxFieldSecurity from './jabvoxFieldSecurity.json';
import jabvoxInternalChat from './jabvoxInternalChat.json';
import jabvoxIpWhitelist from './jabvoxIpWhitelist.json';
import jabvoxKanban from './jabvoxKanban.json';
import jabvoxContacts from './jabvoxContacts.json';
import jabvoxLeads from './jabvoxLeads.json';
import jabvoxManagementStates from './jabvoxManagementStates.json';
import jabvoxProducts from './jabvoxProducts.json';
import jabvoxReports from './jabvoxReports.json';
import jabvoxEmail from './jabvoxEmail.json';
import jabvoxActions from './jabvoxActions.json';
import jabvoxBilling from './jabvoxBilling.json';
import jabvoxForms from './jabvoxForms.json';
import jabvoxClickToCall from './jabvoxClickToCall.json';
import jabvoxSoftphone from './jabvoxSoftphone.json';
import jabvoxCustomization from './jabvoxCustomization.json';
import jabvoxWhatsappTemplates from './jabvoxWhatsappTemplates.json';
import jabvoxWhatsappFlows from './jabvoxWhatsappFlows.json';
import jabvoxTasks from './jabvoxTasks.json';
import jabvoxBulkWhatsapp from './jabvoxBulkWhatsapp.json';
import jabvoxWhatsappGroups from './jabvoxWhatsappGroups.json';
import jabvoxVoiceBroadcast from './jabvoxVoiceBroadcast.json';
import jabvoxTickets from './jabvoxTickets.json';
import jabvoxLeadImport from './jabvoxLeadImport.json';
import jabvoxDataExport from './jabvoxDataExport.json';
import jabvoxAdvancedAutomations from './jabvoxAdvancedAutomations.json';
import jabvoxSaldo from './jabvoxSaldo.json';
import jabvoxAiBudget from './jabvoxAiBudget.json';
import jabvoxSms from './jabvoxSms.json';
import jabvoxVoip from './jabvoxVoip.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import sessionLimit from './sessionLimit.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import supportWidget from './supportWidget.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...jabvoxAffiliatePortal,
  ...jabvoxAffiliates,
  ...jabvoxAiChat,
  ...jabvoxProvisioningChat,
  ...jabvoxAudioAnalysis,
  ...jabvoxAnalytics,
  ...jabvoxCdr,
  ...jabvoxCalendar,
  ...jabvoxDialer,
  ...jabvoxFieldSecurity,
  ...jabvoxInternalChat,
  ...jabvoxIpWhitelist,
  ...jabvoxKanban,
  ...jabvoxContacts,
  ...jabvoxLeads,
  ...jabvoxManagementStates,
  ...jabvoxProducts,
  ...jabvoxReports,
  ...jabvoxEmail,
  ...jabvoxActions,
  ...jabvoxBilling,
  ...jabvoxForms,
  ...jabvoxClickToCall,
  ...jabvoxSoftphone,
  ...jabvoxCustomization,
  ...jabvoxWhatsappTemplates,
  ...jabvoxWhatsappFlows,
  ...jabvoxTasks,
  ...jabvoxBulkWhatsapp,
  ...jabvoxWhatsappGroups,
  ...jabvoxVoiceBroadcast,
  ...jabvoxTickets,
  ...jabvoxLeadImport,
  ...jabvoxDataExport,
  ...jabvoxAdvancedAutomations,
  ...jabvoxSaldo,
  ...jabvoxAiBudget,
  ...jabvoxSms,
  ...jabvoxVoip,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...mfa,
  ...onboarding,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...sessionLimit,
  ...settings,
  ...signup,
  ...sla,
  ...supportWidget,
  ...teamsSettings,
  ...whatsappTemplates,
};
